export default __webpack_public_path__ + "static/media/107.a994d625.gif";